export default "__VITE_ASSET__yBa2sjra__"